export const getData = (res, key: string) =>
  res?.relationships?.[key]?.data || res?.relationships?.[key];
